import { render } from "./Cite.vue?vue&type=template&id=f19ba4a8"
import script from "./Cite.vue?vue&type=script&lang=ts"
export * from "./Cite.vue?vue&type=script&lang=ts"
script.render = render

export default script